<template>
	<VSheet
		class="rounded-lg summary"
		width="314px"
	>
		<CardItem>
			<p class="text-subtitle-1 mt-2 mb-4">
				{{ $t('components.summaryView.title') }}
			</p>
			<p
				v-for="item in menuItems"
				:key="item.hash"
				class="text-body-1 px-4 py-2 pointer summary-border"
				:class="item.hash === current ? 'summary-border-active' : ''"
				@click="onChange(item.hash)"
			>
				{{ item.text }}
			</p>
		</CardItem>
	</VSheet>
</template>

<script lang="ts">
	import Vue, { PropType } from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { MenuItem } from '@cnamts/vue-dot/src/patterns/ContextualMenu/types';
	import CardItem from '@/components/CardItem/CardItem.vue';

	const Props = Vue.extend({
		props: {
			menuItems: {
				type: Array as PropType<Array<MenuItem>>,
				required: true
			}
		}
	});

	const MixinsDeclaration = mixins(Props);

	@Component<SummaryView>({
		components: { CardItem }
	})
	export default class SummaryView extends MixinsDeclaration {
		current: string | null = null;

		mounted() {
			addEventListener('scroll', this.onScroll);
		}
		destroyed() {
			removeEventListener('scroll', this.onScroll);
		}

		onScroll(): void {
			const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop || 0;
			this.current = this.menuItems[0]?.hash;
			for (let i = 1; i < this.menuItems.length; ++i) {
				const item = this.menuItems[i];
				if (!item.hash) {
					continue;
				}
				const element = document.getElementById(item.hash.slice(1));
				if (element) {
					const elementPosition =
						element.getBoundingClientRect().top - 30 + scrollPosition;
					if (scrollPosition >= elementPosition) {
						this.current = item.hash;
					}
				}
			}
		}

		onChange(value: string): void {
			if (!value) {
				window.scrollTo({ top: 0, behavior: 'smooth' });
				return;
			}
			const element = document.getElementById(value.slice(1));
			if (element) {
				element.scrollIntoView({ behavior: 'smooth' });
			}
		}
	}
</script>

<style lang="scss" scoped>
@import '@cnamts/design-tokens/dist/tokens';

.summary {
  position: sticky;
  top: 40px;
  z-index: 1;
  height: fit-content;
}
.summary-border {
	border-left: 2px solid $vd-grey-base;
	border-radius: 0 !important;
	color: rgba(0, 0, 0, 0.6);
}
.summary-border-active {
	border-left: 4px solid $vd-am-blue-base;
	color: $vd-am-blue-base;
}
</style>
